import $ from "jquery";
import ajax from "../abstracts/abstract-ajax";
import replacePlaceholder from "../abstracts/abstract-replacePlaceholder";

const loadMode = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        const el = {
            productsWrapper: ".js-products",
            main: ".js-loadMore",
            wrapper: ".js-loadMoreWrapper",
            templateButton: ".js-loadMore-Template",
            card: "#js-template-productCard",
            cardSpec: "#js-template-productCardSpecification",
        };
        if ($(el.main).length === 0) return;

        $(document).on("click", el.main, function (e) {
            e.preventDefault();
            const page = $(this).data("page");
            const limit = $(this).data("limit");
            const total = $(this).data("total_page");
            const thisEl = $(this);
            thisEl.attr("disabled", true);
            const { regex, replaceFn, replaceFnWith } = replacePlaceholder();

            ajax(thisEl, {
                page,
                limit,
            })
                .then((res) => {
                    const templateButton = $(el.templateButton).html();
                    const templateCard = $(el.card).html();
                    const templateCardSpec = $(el.cardSpec).html();

                    const products = res
                        ?.map((prod) => {
                            const cardHtml = templateCard
                                .replace(/{{loop-specifications}}/g, () => {
                                    const cardSpec = prod.specifications
                                        ?.map((spec) => {
                                            const cardSpecHtml =
                                                templateCardSpec.replace(
                                                    regex,
                                                    replaceFnWith(spec),
                                                );
                                            return cardSpecHtml;
                                        })
                                        .join("\n");
                                    return cardSpec;
                                })
                                .replace(/{{is-sold}}/g, () => {
                                    return prod.stock === 0 ? "Sold" : "";
                                })
                                .replace(/{{is-sold-hide}}/g, () => {
                                    return prod.stock === 0
                                        ? "display:none"
                                        : "";
                                })
                                .replace(/{{sold-badge}}/g, () => {
                                    return prod.stock === 0
                                        ? `<span class="Sold__Text heading-h-4-medium base-white">Verkocht</span>`
                                        : "";
                                })
                                .replace(regex, replaceFn(prod));
                            console.log(prod, regex);
                            return cardHtml;
                        })
                        .join("\n");

                    const buttonHtml = templateButton?.replace(
                        /{{page}}/g,
                        page + 1,
                    );
                    $(el.productsWrapper).append(products);

                    $(`${el.wrapper} > ${el.main}`).remove();
                    if (page < total) {
                        $(el.wrapper).append(buttonHtml);
                    }
                })
                .catch();
        });
    };
    init();
};

try {
    loadMode();
} catch (error) {
    console.error("loadMode", error);
}
